import React from "react"

export function TableHeader({columns}) {
  const tableheaders = columns.map((column) => {
    return (
      <th id={column.key} data-testid="th" key={column.key} width={`${column.width}%`}>
        {column.label}
      </th>
    )
  })
  return (
    <thead className="table-header">
      <tr>{tableheaders}</tr>
    </thead>
  )
}
